import React, { forwardRef } from 'react';
import Checkbox from 'components/common/input-components/checkbox';
import type { CheckboxProps } from 'antd';

const BigCheckbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => <Checkbox ref={ref} {...props} big />);

BigCheckbox.displayName = 'BigCheckbox';

export default BigCheckbox;
